/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CustomerBranding } from "layout/MainLayout/Header/HeaderContent/Customer_Branding";
import { Profile } from "./Profile";
import { Notifications } from "./Notifications";
import { Help } from "./Help";
import { Feedback } from "./Feedback";

const HeaderContent = () => {
    
    return (
        <div className='simplicity-brand-header no-print'>

            {/* Customer Brand Area */}
            <div className='header-left'>
                <CustomerBranding/>
            </div>

            {/* currently unused */}
            <div className='header-central'></div>

            {/* Right side help and profile */}
            <div className='simplicity-help-profile-area'>
                <Help/>

                <Feedback/>

                <Notifications/>

                <Profile/>
            </div>
        </div>
    );
};

export { HeaderContent };
